import { TConfig } from '@@/auto/interfaces';

import classes from './ContactSupport.module.css';

export type TContactSupport = Pick<TConfig, 'supportEmail'>;

function ContactSupport({ supportEmail }: TContactSupport) {
  return (
    <p>
      Please contact support at{' '}
      <a href={`mailto:${supportEmail}`} className={classes.support_link}>
        {supportEmail}
      </a>{' '}
      if you continue to experience problems.
    </p>
  );
}

export default ContactSupport;
